import React from 'react';
import { useAutoLoanMarketplace } from './hooks/autoLoanMarketPlace.hook';
import AutoLoanMarketplaceModuleView from './AutoLoanMarketplaceModuleView';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import { AUTO_PURCHASE } from 'types/morph.pagePosition.constants';
import { useCommonAutoLoanHook } from './hooks/autoLoan.hook';

const AutoLoanMarketplaceController = props => {
  const { eventHandler, creditInfo, userInfo } = props;

  const { commonStates, displayModal, hideModal, setCommonStates } =
    useCommonAutoLoanHook({
      eventHandler,
    });

  const {
    state,
    sortList,
    MIN_NEW_AUTOLOAN,
    MAX_NEW_AUTOLOAN,
    setNewAutoLoanAmount,
    onNewAutoLoanDownPaymentUpdate,
    onApplyFilter,
    onResetFilter,
    onRemoveTagFilter,
    setCurrentSortType,
    isApplyFilterDisabled,
  } = useAutoLoanMarketplace(
    creditInfo,
    userInfo,
    eventHandler,
    setCommonStates,
    props.getAutoLoans,
    props?.module,
  );

  const loading = props.globalLoadingFlag || !creditInfo || !userInfo;

  const trackingAtr = getViewModuleTrackingAttributes({
    pagePosition: AUTO_PURCHASE,
    modulePosition: props.modulePosition,
    vertical: 'Auto Loan',
  });

  const seenModuleTracking = useSeenModulePixel(trackingAtr);

  if (loading) {
    return <PageLoadingMask />;
  } else {
    return (
      <AutoLoanMarketplaceModuleView
        {...props}
        {...state}
        {...commonStates}
        sortList={sortList}
        MIN_NEW_AUTOLOAN={MIN_NEW_AUTOLOAN}
        MAX_NEW_AUTOLOAN={MAX_NEW_AUTOLOAN}
        setCurrentSortType={setCurrentSortType}
        setNewAutoLoanAmount={setNewAutoLoanAmount}
        onNewAutoLoanDownPaymentUpdate={onNewAutoLoanDownPaymentUpdate}
        displayModal={displayModal}
        hideModal={hideModal}
        onApplyFilter={onApplyFilter}
        onResetFilter={onResetFilter}
        isApplyFilterDisabled={isApplyFilterDisabled}
        onRemoveTagFilter={onRemoveTagFilter}
        seenModuleTracking={seenModuleTracking}
        moduleName={AUTO_PURCHASE}
      />
    );
  }
};

export default AutoLoanMarketplaceController;
